import styled from 'styled-components';

export const Container = styled.div<{
  $margin: string;
}>`
  margin: ${({ $margin }) => $margin};
`;

export const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Date = styled.div`
  font-size: 10px;
  line-height: 13px;
  margin: 0;
  color: var(--mainColor);
  font-weight: 700;
`;

export const Value = styled.p`
  font-size: 10px;
  line-height: 13px;
  margin: 0;
`;

export const ValueHighlighted = styled(Value)`
  font-weight: bold;
  flex: 1;
`;
